// @flow
import type { AppState } from 'modules/rootReducer';
import type { GalleryImageType } from 'types/common';
import type { ProjectOverlayDescriptionData } from 'types/project';

const getGallery = (state: AppState): Array<GalleryImageType> | null => {
  return state.architects.gallery;
};

const getGalleryLoading = (state: AppState): boolean => {
  return state.architects.loading.gallery;
};

const getGalleryError = (state: AppState): string | null => {
  return state.architects.error.gallery;
};

const getProjectOverlay = (
  state: AppState
): Array<ProjectOverlayDescriptionData> | null => {
  return state.architects.projectOverlayData;
};

const getProjectOverlayLoading = (state: AppState): boolean => {
  return state.architects.loading.projectOverlayData;
};

const getProjectOverlayError = (state: AppState): string | null => {
  return state.architects.error.projectOverlayData;
};

const isLoading = state => {
  return getGalleryLoading(state) && getProjectOverlayLoading(state);
};

export const ArchitectsSelector = {
  isLoading,
  getGallery,
  getGalleryLoading,
  getGalleryError,
  getProjectOverlay,
  getProjectOverlayLoading,
  getProjectOverlayError,
};
